import { HoldListQuery } from './holds_list_query';
import { HoldPriorityFeedQuery } from './holds_priority_feed_query';

angular
  .module('capability-ng-holds')
  .service('ngHoldPriorityFeedQuery', HoldPriorityFeedQuery)
  .service('ngHoldListQuery', HoldListQuery);

export * from './holds_list_query';
export * from './holds_priority_feed_query';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/queries/holds_queries_module.ts